import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Save } from "lucide-react";
import { OrderWindowStatus } from "@/components/DemandSummary";

const ZONES = ["Asia/Kolkata", "Asia/Dubai", "Asia/Singapore", "Asia/Dhaka", "Asia/Kathmandu", "Asia/Colombo", "Europe/London", "America/New_York", "UTC"];

export function OrderScheduleTab() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/org/order-schedule").then((r) => setS(r.data)); }, []);
  if (!s) return null;
  const set = (k, v) => setS({ ...s, [k]: v });
  const save = async () => {
    try { const r = await api.put("/org/order-schedule", { enabled: s.enabled, open: s.open, close: s.close, timezone: s.timezone }); setS(r.data); toast.success("Order schedule saved"); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };
  return (
    <div className="space-y-4 rounded-2xl border border-[#E5E0D8] bg-white p-5" data-testid="order-schedule-tab">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="font-heading font-semibold text-stone-900">Daily partner ordering window</p>
          <p className="text-sm text-stone-500">Partners can place orders only inside this window, every day. Outside it, your team manages received orders and can create emergency orders.</p>
        </div>
        <label className="flex items-center gap-2 text-sm font-medium"><Switch checked={s.enabled} onCheckedChange={(v) => set("enabled", v)} data-testid="schedule-enabled-switch" /> {s.enabled ? "On" : "Off"}</label>
      </div>
      <div className="grid gap-4 sm:grid-cols-3">
        <div><Label>Orders open at</Label><Input type="time" className="mt-1" value={s.open} onChange={(e) => set("open", e.target.value)} data-testid="schedule-open-input" /></div>
        <div><Label>Orders close at</Label><Input type="time" className="mt-1" value={s.close} onChange={(e) => set("close", e.target.value)} data-testid="schedule-close-input" /></div>
        <div><Label>Timezone</Label>
          <Select value={s.timezone} onValueChange={(v) => set("timezone", v)}>
            <SelectTrigger className="mt-1" data-testid="schedule-timezone-select"><SelectValue /></SelectTrigger>
            <SelectContent>{ZONES.map((z) => <SelectItem key={z} value={z}>{z}</SelectItem>)}</SelectContent>
          </Select>
        </div>
      </div>
      <OrderWindowStatus win={s} />
      <p className="text-xs text-stone-400">Changes apply to new orders only; existing orders are not affected. Who can create emergency orders is set by the "Order Management → Create" permission.</p>
      <Button onClick={save} className="bg-[#0D5C3A] hover:bg-[#084229]" data-testid="schedule-save-btn"><Save className="mr-1 h-4 w-4" /> Save schedule</Button>
    </div>
  );
}
